module.exports = __webpack_public_path__ + "public/files/img/avatar-s-20.32972323.jpg";